export default __webpack_public_path__ + "static/Jan_Huijgers_1-993ce23d2d01e6b8b609669fbc0a6b93.jpg";